export const $intent = Symbol('intent');
export const $intents = Symbol('intents');

//# sourceMappingURL=constants.js.map